import { gql } from "@apollo/client";

export const updateLens = gql`
    mutation updateLens(
        $lensId: ID!
        $previewMediaResources: [PreviewMediaResource!]
        $spectaclesTags: [String!]
        $creatorRewardProgramEnrolled: Boolean!
        $description: String
        $lensCta: MyLensesLensCtaInput
        $lensName: String
        $profileVisibility: Visibility
        $submissionId: ID
        $tags: [String!]
        $isGameUserProvided: Boolean!
    ) {
        updateLens(
            input: {
                lensId: $lensId
                previewMediaResources: $previewMediaResources
                spectaclesTags: $spectaclesTags
                creatorRewardProgramEnrolled: $creatorRewardProgramEnrolled
                description: $description
                lensCta: $lensCta
                lensName: $lensName
                profileVisibility: $profileVisibility
                submissionId: $submissionId
                tags: $tags
                isGameUserProvided: $isGameUserProvided
            }
        ) {
            lens {
                id
                name
                description
                visibility
                tagsList
                spectaclesTags
                lensCreatorPayoutEligibility
                lensCta {
                    type
                    text
                    website {
                        url
                    }
                    deeplink {
                        androidAppUrl
                        appName
                        iosAppId
                        uri
                    }
                }
                previewMediaList {
                    mediaId
                    thumbnailMediaUrl
                    thumbnailMediaPosterUrl
                    standardMediaUrl
                    standardMediaPosterUrl
                }
                updatedAt {
                    seconds
                    nanos
                }
            }
        }
    }
`;
